import React, { useState, useContext } from "react";
import "./BuildFreeExterior.css";
import { LanguageContext } from "../../context/LanguageContext";

import CarCloudBlue from "../../assets/images/buildFree/blueCar.webp";
import CarStarNightBlack from "../../assets/images/buildFree/blackCar.webp";
import CarSnowWhite from "../../assets/images/buildFree/whiteCar.webp";
import CarSkyBlue from "../../assets/images/buildFree/skyblueCar.webp";
import CarDarkGreen from "../../assets/images/buildFree/darkGreenCar.webp";

import ThumbCloudBlue from "../../assets/images/buildFree/blueColor.webp";
import ThumbStarNightBlack from "../../assets/images/buildFree/blackColor.webp";
import ThumbSnowWhite from "../../assets/images/buildFree/whiteColor.webp";
import ThumbSkyBlue from "../../assets/images/buildFree/skyBlueColor.webp";
import ThumbDarkGreen from "../../assets/images/buildFree/darkGreenColor.webp";

const COLORS = [
  {
    id: 1,
    name: "Cloud Blue",
    carImg: CarCloudBlue,
    thumb: ThumbCloudBlue,
  },
  {
    id: 2,
    name: "Star Night Black",
    carImg: CarStarNightBlack,
    thumb: ThumbStarNightBlack,
  },
  {
    id: 3,
    name: "Snow White",
    carImg: CarSnowWhite,
    thumb: ThumbSnowWhite,
  },
  {
    id: 4,
    name: "Sky Blue",
    carImg: CarSkyBlue,
    thumb: ThumbSkyBlue,
  },
  {
    id: 5,
    name: "Dark Green",
    carImg: CarDarkGreen,
    thumb: ThumbDarkGreen,
  },
];

const BuildFreeExterior = ({ onSelect }) => {
  const { texts } = useContext(LanguageContext);
  const t = texts.buildFree || {};
  const exteriorLabels = t.exteriors || {};

  const [selected, setSelected] = useState(COLORS[4]);

  const handleSelect = (c) => {
    setSelected(c);
    onSelect(c);
  };

  return (
    <div className="build-exterior">
      <div className="build-top">
        <h1 className="build-title">{t.buildYourCar}</h1>
        <h2 className="build-model">{t.modelName}</h2>
        <h4 className="choose-title">{t.chooseExterior}</h4>
      </div>

      <div className="build-main">
        <div className="car-display">
          <img src={selected.carImg} className="car-img" alt="" />
        </div>

        <div className="color-list">
          {COLORS.map((c) => (
            <div
              key={c.id}
              className={`color-item ${selected.id === c.id ? "active" : ""}`}
              onClick={() => handleSelect(c)}
            >
              <div className="color-thumb-wrapper">
                <img src={c.thumb} alt="" />
              </div>
              <p className="color-name">{exteriorLabels[c.name] || c.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuildFreeExterior;
